// extracted by mini-css-extract-plugin
export default {"topNav":"PY-z","category":"QY-z","noArrow":"RY-z","alternative":"SY-z","topLevelNavItem":"TY-z","navContainer":"UY-z","subcategoryHeading":"VY-z","subcategory":"WY-z"};